import { clear_token, get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';
import dayGridPlugin from "@fullcalendar/daygrid";
import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import FloatingButton from '@/components/FloatingButton/FloatingButtonComponent.vue'
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';
import { handle_event_list_realtime } from "@/services/eventRealtimeHandlers";


const CALENDAR_ID = process.env.VUE_APP_CALENDAR_ID;
import { client_domain } from "@/main.js";


export default {
  components: {
    Sidebar,
    Navbar,
    FloatingButton,
    InactivityModal
  },
  data() {
    return ({
      ticket: {
      name: '',
      },
      selectedTickets: [],
      recurring_patterns: [],
      is_recurring: false,
      event_tickets:[],
      allTickets: [],
      tickets: [],
      past_events: [],
      is_free: true,
      assignedTicketIds:[],
      edit_end_date:'',
      edit_start_date:'',
      edit_ticket_id:'',
      edit_name:'',
      edit_is_sold_out:'',
      edit_price:'',
      businessName: '',
      isFirstTime: false,
      searchQuery: "",
      selectedEvent: {},
      activeDates: {},
      selectedItemId:null,
      cbo_domain: false,
      workbook_domain: false,
      styledCalendarId: CALENDAR_ID,
      imagePreview: null,
      event_link: "",
      event_types:[],
      event_type: '',
      events: [],
      event_id: null,
      token_exists: false,
      selectedExtraId: [],
      selectedExtraItemId: [],
      selectedItemId: [],
      eventExtras: [],
      extraItems: [],
      user_details: {
        "user_role": '',
        "first_name": '',
        "last_name": '',
      },
      chapter: "",
      chapters: [
        "Bedfordview",
        "Edevale",
        "Kempton Park",
        "Kyalami",
        "East Rand",
      ],
      currentMonthYear: "",
      selectedEvent: {},
      portals: [],
      selectedPortalId: '',
      event_name: "",
      description: "",
      start_date: "",
      start_time: '',
      end_date: "",
      end_time: '',
      rsvp_start_date: "",
      rsvp_start_time: '',
      rsvp_end_date: "",
      rsvp_end_time: '',
      organizer: "",
      location: "",
      portal_id: "",
      files: [],
      latitude: null,
      longitude: null,
      loading: true,
      upload_media: null,
      fileName: '',
      event_description: '',
      errors: {},
      menu_name: "",
      menu_items: [],
      filteredExtras: [],
      item_name: '',
      item_description: '',
      item_price: 0,
      selectedExtraText: '',
      showExtrasForm: false,
      isSubmitting: false,
      extras: [],
      extraForms: [],
      show_add_extras:true,
      currentDate: new Date(),
      weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      year: new Date().getFullYear(),
      month: new Date().getMonth(),
      days: [],
        selectedDate: new Date(),
        calendarOptions: {
          plugins: [dayGridPlugin],
          events: [],
          currentMonth: new Date().getMonth(),
          currentYear: new Date().getFullYear(),
          selectedDate: null,
          weekdays: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
          daysInMonth: [],
          initialDate: new Date().toISOString().split('T')[0],
    },
    });
  },
  mounted() {

    this.token_exists = get_token();
    const selectedEvent = JSON.parse(sessionStorage.getItem('selectedEvent'));
    const selectedExtras = JSON.parse(sessionStorage.getItem('selectedExtras')) || [];
    const selectedExtraItems = JSON.parse(sessionStorage.getItem('selectedExtraItems')) || [];
    const selectedItemId = JSON.parse(sessionStorage.getItem('selectedItemId')) || [];
    const businessName = JSON.parse(sessionStorage.getItem('businessName')) || '';
    const isFirstTime = JSON.parse(sessionStorage.getItem('isFirstTime')) || false;
    const chapter = JSON.parse(sessionStorage.getItem('chapter')) || false;



    const nextUrl = sessionStorage.getItem('next');

    if (nextUrl && this.token_exists) {

        this.selectedEvent = selectedEvent;
        this.selectedExtraId = selectedExtras;
        this.selectedExtraItemId = selectedExtraItems;
        this.selectedItemId = selectedItemId
        this.businessName = businessName;
        this.isFirstTime = isFirstTime;
        this.chapter = chapter;
        if (typeof this.addRsvp === 'function') {
          this.addRsvp()
          sessionStorage.removeItem('next');
          sessionStorage.removeItem('selectedEvent');
          sessionStorage.removeItem('selectedExtras');
          sessionStorage.removeItem('selectedExtraItems');
          sessionStorage.removeItem('selectedItemId')
          sessionStorage.removeItem('businessName');
          sessionStorage.removeItem('isFirstTime');
          sessionStorage.removeItem('chapter');
      }
    }

    this.fetchEventTypes();
    // const script = document.createElement('script');
    // script.src = "https://embed.styledcalendar.com/assets/parent-window.js";
    // script.async = true;
    // script.type = "module";
    // document.body.appendChild(script);
    this.fetchEvents().then(() => {
  this.$nextTick(() => {
    if ($.fn.DataTable.isDataTable('#table')) {
      $('#table').DataTable().clear().destroy();
    }
    $('#table').DataTable({
      paging: true,
      searching: true,
      ordering: true,
      info: true,
      lengthChange: true,
      pageLength: 10,
      order: [], // replace sortColumn/sortDirection
      language: {
        paginate: {
          previous: "Previous",
          next: "Next"
        },
        info: "Showing _START_ to _END_ of _TOTAL_ entries",
        infoEmpty: "No entries available"
      }
    });
  });
});

    this.fetchPortals();
    this.user_details = get_user_details();
    this.filteredExtras = this.extras;
    this.filter_past_events();
    this.fetchRecurringTypes();
    this.$nextTick(() => {
      const modalEl = this.$refs.calendarModal;

      if (modalEl) {
        $(modalEl).on('shown.bs.modal', () => {
          if (this.$refs.fullCalendar) {
            this.$refs.fullCalendar.getApi().render();
          }
        });
      }
    });

    this.load_events_modal();


    if (client_domain.includes('cbo')) {
      this.cbo_domain = true;
    }

    if (client_domain.includes('workbook')) {
      this.workbook_domain = true;
    }

    this.$nextTick(() => {
      $('#rsvpTable').DataTable();
    });
    this.get_all_tickets();

    this._realtime_event_handler = (evt) => this.handle_realtime_event(evt);
    window.addEventListener("realtime:event", this._realtime_event_handler);

  },
  computed: {
    monthName() {
      return ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ][this.month];
    },
    year() {
      return this.currentDate.getFullYear();
    },

    filteredEvents() {
      let groupedEvents = {};
      this.events.forEach((event) => {
        let eventDate = this.form_date(event.start_date); // Format date if needed
        if (!groupedEvents[eventDate]) {
          groupedEvents[eventDate] = [];
        }
        groupedEvents[eventDate].push(event);
      });
      return groupedEvents;
    },
    selectedTicketsData() {
    return this.selectedTickets
      .map(id => {
        const t = this.allTickets.find(ticket => Number(ticket.id) === Number(id));
        if (!t) return null;

        // Check if this ticket is already assigned
        const assigned = this.event_tickets?.find(et => Number(et.ticket.id) === Number(id));

        return {
          id: t.id,
          name: t.name,
          price: assigned ? parseFloat(assigned.price) : 0,
          quantity: assigned ? Number(assigned.quantity) : 1,
          start_date: assigned ? assigned.start_date?.substring(0,16) : '',
          end_date: assigned ? assigned.end_date?.substring(0,16) : '',
          readOnly: !!assigned
        };
      })
      .filter(Boolean);
    },
  },
  beforeUnmount() {
    if (this._realtime_event_handler) {
      window.removeEventListener("realtime:event", this._realtime_event_handler);
      this._realtime_event_handler = null;
    }
  },
  watch: {
    selectedExtraText(newVal) {
      this.filterExtras(newVal);
    },
    event_name(newValue) {
      if (newValue.trim()) this.errors.event_name = null;
    },
    location(newValue) {
      if (newValue.trim()) this.errors.location = null;
    },
    organizer(newValue) {
      if (newValue.trim()) this.errors.organizer = null;
    },
    start_date() {
      this.errors.start_date = null;
    },
    end_date() {
      this.errors.end_date = null;
    },
    rsvp_start_date() {
      this.errors.rsvp_start_date = null;
    },
    rsvp_end_date() {
      this.errors.rsvp_end_date = null;
    },
    event_type: {
      handler(newType) {
        if (newType.name !== "online") {
          this.$nextTick(() => {
            this.initializeMap();

          });
        }
      },
      deep: true
    },
    events: {
      handler() {
        this.$nextTick(() => {
          // Prevent reinitializing if already initialized
          if ($.fn.DataTable.isDataTable('#rsvpTable')) {
            $('#rsvpTable').DataTable().destroy();
          }

          $('#rsvpTable').DataTable({
            paging: true,
            searching: true,
            ordering: true,
            info: true,
            lengthChange: true,
            pageLength: 10,
            language: {
              paginate: {
                previous: "Previous",
                next: "Next"
              },
              info: "Showing _START_ to _END_ of _TOTAL_ entries",
              infoEmpty: "No entries available"
            }
          });
        });
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handle_realtime_event(event) {
      handle_event_list_realtime(this, event, { list_names: ["events", "past_events"] });
    },

    view_event(event) {
      this.event_id = event.id;
      if(event.is_free === false){
        window.location.href = `/view_event_tickets_dashboard/${this.event_id}`;
      }
      else{
        window.location.href = `/get_rsvps/${this.event_id}`;
      }
    },
    addMenuItem() {
      this.menu_items.push("");
    },
    removeMenuItem(index) {
      this.menu_items.splice(index, 1);
    },
    filterExtras() {
      const searchText = this.selectedExtraText.toLowerCase();
      this.filteredExtras = this.extras.filter(extra => extra.name.toLowerCase().includes(searchText));
    },
    getToken() {
      return get_token();
    },

    addEventToHome(newEvent) {
      if (newEvent) {
        this.events.unshift(newEvent);
      }
    },
    fetchPortals() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_portals_api/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (data) => {
          this.portals = data.portals;
          this.portals = this.portals.filter(
                  portal => portal.name?.toLowerCase() !== 'default portal'
                );

          setTimeout(() => {
            this.loading = false;
        }, 1000);
        },

        complete: () => {
          this.isLoading = false;
        }
      });
    },

    fetchExtras() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_extra/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (data) => {
          this.extras = data.extras;
          setTimeout(() => {
            this.loading = false;
        }, 1000);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    addMoreExtra() {
      const extraItem = {
        selectedExtraText: this.selectedExtraText,
        item_name: this.item_name,
        item_description: this.item_description,
        item_price: this.item_price,
      };
      this.extraForms.push(extraItem);
      this.selectedExtraText = '';
      this.item_name = '';
      this.item_description = '';
      this.item_price = '';
    },

    handleCollapseToggle() {
      this.isCollapseOpen = !this.isCollapseOpen;

      if (this.isCollapseOpen) {
        this.addMoreExtra();
      }
    },
    addExtra() {
      this.show_add_extras=true
      this.showExtrasForm = true;
      this.extraForms.push({
        selectedExtra: "",
        items: [
          { item_name: '', item_description: '', item_price: '' }
        ]
      });
    },

    addExtraItem(extra_index) {
      const extra_form = this.extraForms.at(extra_index);

      if (extra_form) {
        const new_item = {
          item_name: '',
          item_description: '',
          item_price: 0
        };

        if (this.validate_extra_item(new_item)) {
          extra_form.items.push(new_item);
        }
      }
    },

    validate_extra_item(item) {
      return (
        typeof item === 'object' &&
        item !== null &&
        typeof item.item_name === 'string' &&
        typeof item.item_description === 'string' &&
        typeof item.item_price === 'number' &&
        item.item_price >= 0
      );
    },

    removeExtra(extraIndex) {
      this.extraForms.splice(extraIndex, 1);
    },
    fetchEvents_extras(event_id) {
      this.selectEvent.id = event_id;
      this.isLoading = true;
      this.token_exists = get_token();
      this.clearForm()
      this.selectedItemId=[]

      // Close the event modal before making the request
      $('#eventModal').modal('hide');

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_data/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: { event_id: event_id },
        success: (response_data) => {
          this.eventExtras = response_data.event_extras;
          if (this.eventExtras && this.eventExtras.length > 0) {
            $('#rsvp_modal').modal('show'); // Open RSVP modal
          } else {
            this.addRsvp(); // Call addRsvp if no extra details
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    }
    ,
    get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
    },

    deleteEvent(event_id) {
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: "DELETE",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/delete_event_api/`,
            data: JSON.stringify({ event_id: event_id }),
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            success: (response) => {
              const status = response.status;
              if (status === "success") {
                Swal.fire({
                  title: 'Deleted!',
                  text: 'The event has been deleted.',
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 1000,
                  position: 'bottom-end',
                  toast: true
                }).then(() => {
                  this.past_events = this.past_events.filter(event => event.id !== event_id);
                  this.events = this.events.filter(event => event.id !== event_id);
                  Swal.close();
                });
              }
            },
            error: (response) => {
              Swal.fire({
                title: 'Error!',
                  text: response.responseJSON.message,
                  icon: 'error',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              }

              );
            }
          });
        }
      });
    },
    fetchEventTypes() {
      this.isLoading = true;
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_types/`,
        method: "GET",
        headers: this.token_exists
          ? {
              Authorization: `Token ${this.getToken()}`,
              "Content-Type": "application/json",
            }
          : {},
        success: (response) => {
          this.event_types = response.data.event_type;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    load_events_modal() {
      this.fetchEvents();
    },
    fetchEvents() {
  this.isLoading = true;
  this.token_exists = get_token();

  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/filter_events_api/`,
      method: "POST",
      headers: this.token_exists
        ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
        : {},
      success: (data) => {
        this.events = data.data.results;
        const formattedEvents = this.events.map((event) => ({
          title: event.event_name,
          start: new Date(event.start_date).toISOString(),
          end: new Date(event.end_date).toISOString(),
        }));

        this.calendarOptions.events = formattedEvents;

        // Optional simulated delay
        setTimeout(() => {
          this.loading = false;
        }, 1000);

        resolve(); // ✅ Resolve the promise when done
      },
      error: (error) => {
        console.error('Failed to fetch events:', error);
        reject(error); // ❌ Reject if error occurs
      },
      complete: () => {

        this.isLoading = false;
      },
    });
  });
},
  filter_past_events() {
        this.is_event_loading = true;
        this.token_exists = get_token();
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/filter_past_events/`,
          method: "POST",
          headers: this.token_exists
            ? {
              Authorization: `Token ${this.getToken()}`,
              "Content-Type": "application/json",
            }
            : {},
          success: (data) => {

            this.past_events = data.data.events;

            setTimeout(() => {
              this.loading = false;
          }, 300);

          },
          complete: () => {
        this.is_event_loading = false;
      },
        });
      },
    openEditModal(event) {
      // Populate eventData for editing
      this.eventData = { ...event };
      this.fileName = event.file ? event.file.name : '';
      $('#event_modal').modal('show');

    },

    submitEvent() {
      if (this.event_id) {
        this.update_event(this.event_id);
      } else {
        this.submit_form();
      }
    },
    log_out() {
      clear_token()
      this.$router.push({ path: '/', });
    },

    initializeMap() {
      const defaultLat = parseFloat(this.latitude || 0);
      const defaultLng = parseFloat(this.longitude || 0);

      const mapOptions = {
        center: { lat: defaultLat, lng: defaultLng },
        zoom: 8,
        mapTypeId: 'roadmap',
      };

      const mapElement = document.querySelector('#mapSearchBox');
      if (mapElement) {
        const map = new window.google.maps.Map(mapElement, mapOptions);

        let marker = null;

        const input = document.getElementById('mapSearchBox');
        const searchBox = new window.google.maps.places.SearchBox(input);

        map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);

        map.addListener('bounds_changed', () => {
          searchBox.setBounds(map.getBounds());
        });

        searchBox.addListener('places_changed', () => {
          const places = searchBox.getPlaces();

          if (!places || places.length === 0) {
            return;
          }

          const place = places[0];
          if (!place.geometry) {
            return;
          }

          // Update map center and zoom
          map.setCenter(place.geometry.location);
          map.setZoom(14);

          // Remove the existing marker, if any
          if (marker) {
            marker.setMap(null);
          }

          marker = new window.google.maps.Marker({
            position: place.geometry.location,
            map: map,
            title: place.name,
          });
          this.location = input.value;
        });
      }
    },
get_event_tickets() {

      $.ajax({
        type: "GET",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_tickets/`,
        headers: {
          Authorization: `Token ${this.getToken()}`
        },
        success: (response) => {

          this.event_tickets = response.tickets || [];
        },
        error: (xhr) => {

          if (xhr.status === 401) {
              window.location.href = "/sign_in_finale";
            }
        }
      });
    },
    get_all_tickets() {
    
          $.ajax({
            type: "GET",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_tickets_type/`,
            headers: {
              Authorization: `Token ${this.getToken()}`
            },
            success: (response) => {
              this.allTickets = response.tickets || [];
            },
            error: () => {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "Unable to fetch available tickets. Please try again.",
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          });
        },
update_event() {
  Swal.fire({
    title: "Updating...",
    text: "Please wait while we update the event.",
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  const formData = new FormData();

  formData.append("event_id", this.event_id);
  formData.append("event_name", this.event_name);
  this.event_description = this.$refs.quillEventEditorRef.getHTML();
  formData.append('description', this.event_description);
  formData.append("start_date", this.start_date);
  formData.append("start_time", this.start_time);
  formData.append("end_date", this.end_date);
  formData.append("end_time", this.end_time);
  formData.append("rsvp_start_date", this.rsvp_start_date);
  formData.append("rsvp_start_time", this.rsvp_start_time);
  formData.append("rsvp_end_date", this.rsvp_end_date);
  formData.append("rsvp_end_time", this.rsvp_end_time);
  formData.append("organizer", this.organizer);
  formData.append("location", this.location);
  formData.append("event_type", this.event_type.id);
  formData.append('is_free', this.is_free ? "true" : "false");

  if (this.event_link) {
    formData.append("event_link", this.event_link);
  }

  // 🧩 Build extras data array
  const extras_data = [];

  this.extraForms.forEach(extra => {
    if (extra.selectedExtra && extra.selectedExtra.trim()) {
      const validItems = [];

      extra.items.forEach(item => {
        if (item.item_name && item.item_name.trim()) {
          validItems.push({
            id: item.id, // include ID if updating
            item_name: item.item_name.trim(),
            description: item.item_description?.trim(),
            price: item.item_price || 0
          });
        }
      });

      if (validItems.length > 0) {
        extras_data.push({
          id: extra.id, // include ID if available
          extra_name: extra.selectedExtra,
          items: validItems
        });
      }
    }
  });

  if (extras_data.length > 0) {
    formData.append("extra", JSON.stringify(extras_data));
  }

  if (this.upload_media) {
    formData.append("file", this.upload_media);
  }

  if (this.files && this.files.length > 0) {
    this.files.forEach((file) => {
      formData.append(`file`, file);
    });
  }
  if (this.is_free === false) {
      const ticketsPayload = this.selectedTicketsData.map(t => ({
        ticket_id: t.id,
        price: t.price,
        quantity: t.quantity,
        start_date: t.start_date,
        end_date: t.end_date,
      }));

      formData.append('tickets', JSON.stringify(ticketsPayload));
    }

  $.ajax({
    type: "POST",
    url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/update_event_api/`,
    data: formData,
    processData: false,
    contentType: false,
    headers: {
      Authorization: `Token ${this.getToken()}`,
    },
    success: (response) => {
      if (response.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.message,
          showConfirmButton: false,
          timer: 2000,
          position: 'bottom-end',
          toast: true
        }).then(() => {
          $("#update_event_modal").modal("hide");
          $('#event_modal').modal('hide');
          this.load_event();
        });
      }
    },
    error: () => {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Error",
        text: 'An error occurred while trying to update the Event, please try again.',
        showConfirmButton: false,
        timer: 2000,
        position: 'bottom-end',
        toast: true
      });
    },
  });
},


  load_event() {

      this.fetchEvents();

      $("#update_event_modal").modal("hide");
      $('#event_modal').modal('hide');


      this.event_id = null;
      this.event_name = "";
      this.description = "";
      this.start_date = "";
      this.start_time = "";
      this.end_date = "";
      this.end_time = "";
      this.rsvp_start_date = "";
      this.rsvp_start_time = "";
      this.rsvp_end_date = "";
      this.rsvp_end_time = "";
      this.organizer = "";
      this.location = "";
      this.files = [];
    },
    validationEventForm() {
      this.errors = {};
      let valid = true;

      if (!this.event_name) {
        this.errors.event_name = 'Event name is required';
        valid = false;
      }

      return valid;
    },

    handleFileUpload(event) {
      const file = event.target.files[0];

      if (file) {
        if (file.type.startsWith("audio/")) {
          this.fileError = "Audio files are not allowed.";
          this.upload_media = null;
          this.fileName = "";
          this.imagePreview = null; // Reset preview if an invalid file is selected
          event.target.value = ""; // Clear file input
        } else {
          this.fileName = file.name;
          this.fileError = "";
          this.upload_media = file;

          // Check if the file is an image before previewing
          if (file.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onload = (e) => {
              this.imagePreview = e.target.result;
            };
            reader.readAsDataURL(file);
          } else {
            this.imagePreview = null; // Reset preview for non-image files
          }
        }
      } else {
        this.fileName = "";
        this.fileError = "";
        this.upload_media = null;
        this.imagePreview = null;
      }
    },
    clearForm() {
      this.item_name = '';
      this.item_description = '';
      this.item_price = '';
      this.extraItems = [];
      this.event_name = '';
      this.is_free = true;
      this.start_date = '';
      this.end_date = '';
      this.event_description = '';
      this.selectedPortalId = '';
      this.organizer = '';
      this.location = '';
      this.rsvp_start_date = '';
      this.rsvp_end_date = '';
      this.upload_media = null;
      this.selectedExtraText = '';
      this.event_type = '';
      if (this.$refs.quillEventEditorRef) {
        this.$refs.quillEventEditorRef.setHTML('');

      };
      this.extraForms = [];

    },
    fetchRecurringTypes() {
      this.isLoading = true;
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_recurring_pattern/`,
        method: "GET",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        success: (response) => {
          this.recurring_patterns = response.data.recurring_patterns;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    submit_form() {
      this.is_valid = true
      if (!this.validation_event_form()) {
        return;
      }

      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we process your request.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const event_url=`${window.location.origin}${this.$route.path}`

      this.isSubmitting = true;
      const newItem = {
        item_name: this.item_name,
        description: this.item_description,
        price: this.item_price
      };
      this.extraItems.push(newItem);

      const formData = new FormData();
      formData.append('event_name', this.event_name);
      formData.append('start_date', this.start_date);
      formData.append('start_time', this.start_time);
      formData.append('end_date', this.end_date);
      formData.append('end_time', this.end_time);
      this.event_description = this.$refs.quillEventEditorRef.getHTML();
      formData.append('description', this.event_description);
      formData.append('portal_id', this.selectedPortalId);
      formData.append('organizer', this.organizer);
      formData.append('location', this.location);
      formData.append('rsvp_start_date', this.rsvp_start_date);
      formData.append('rsvp_start_time', this.rsvp_start_time);
      formData.append('rsvp_end_date', this.rsvp_end_date);
      formData.append('rsvp_end_time', this.rsvp_end_time);
      formData.append('event_type',this.event_type.id);
      formData.append('event_link', this.event_link);
      formData.append('event_url',event_url)
      formData.append('is_recurring', this.is_recurring);
      formData.append('is_free', this.is_free ? "true" : "false");

      if (this.is_recurring && this.recurring_type) {
        formData.append('recurring_type', this.recurring_type);
      }
      if (this.upload_media) {
        formData.append('file', this.upload_media);
      }

      const extras_data = [];

      this.extraForms.forEach(extra => {
        if (extra.selectedExtra && extra.selectedExtra.trim()) {
          const validItems = [];

          extra.items.forEach(item => {
            if (item.item_name && item.item_name.trim()) {
              validItems.push({
                item_name: item.item_name.trim(),
                description: item.item_description?.trim(),
                price: item.item_price || 0
              });
            }
          });

          if (validItems.length > 0) {
            extras_data.push({
              extra_name: extra.selectedExtra.trim(),
              items: validItems
            });
          }
        }
      });

      if (extras_data.length > 0) {
        formData.append('extra', JSON.stringify(extras_data));
      }
      if (this.is_free === false) {
      const ticketsPayload = this.selectedTicketsData.map(t => ({
        ticket_id: t.id,
        price: t.price,
        quantity: t.quantity,
        start_date: t.start_date,
        end_date: t.end_date,
      }));
      formData.append('tickets', JSON.stringify(ticketsPayload));
    }

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/create_event_api/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
          const status = response.status;
          this.$emit('new_event', response.event)
          Swal.close();
          if (status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Event Created',
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              $('#event_modal').modal('hide');
              this.isDropdownVisible = false;
              this.clearForm();
              this.load_event();
            });
          }
        },
        error: (response) => {
          Swal.close();
          const response_data = response.responseJSON;
          if (response_data.status === "error") {
            this.errors.event_name = response_data.message;
          }
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
    removeExtraItem(extra_index, item_index) {
      const extra_form = this.extraForms.at(extra_index);

      if (extra_form && Array.isArray(extra_form.items)) {
        if (this.validate_item_index(extra_form.items, item_index)) {
          extra_form.items.splice(item_index, 1);
        }
      }
    },

    validate_item_index(items, index) {
      return Number.isInteger(index) && index >= 0 && index < items.length;
    },

    openCreateModal() {
      // Reset form fields for creating a new event
      this.event_name = '';
      this.description = '';
      this.start_date = '';
      this.start_time = '';
      this.end_date = '';
      this.end_time = '';
      this.rsvp_start_date = '';
      this.rsvp_start_time = '';
      this.rsvp_end_date = '';
      this.organizer = '';
      this.location = '';
      this.selectedPortalId = '';
      this.files = [];
      this.event_type= '';
      this.extraItems = [];
      // Show the modal
      $('#event_modal').modal('show');

    },
    formatDateInput(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toISOString().slice(0, 10); // Extracts "YYYY-MM-DD"
    },
    edit_event(event) {
      this.event_name = event.event_name;
      this.event_id = event.id;
      this.description = event.description;
      const TextDescription = event.description.replace(/<[^>]*>/g, "");
      this.$nextTick(() => {
        if (this.$refs.quillEventEditorRef) {
          const quillEditor = this.$refs.quillEventEditorRef.getQuill();
          if (quillEditor) {
            quillEditor.setContents([
              { insert: TextDescription || "" },
            ]);
          }
        }
      });
      this.start_date = event.start_date;
      this.start_time = event.start_time;
      this.end_date = event.end_date;
      this.end_time = event.end_time;
      this.rsvp_start_date = event.rsvp_start_date;
      this.rsvp_start_time = event.rsvp_start_time;
      this.rsvp_end_date = event.rsvp_end_date;
      this.rsvp_end_time = event.rsvp_end_time;
      this.organizer = event.organizer;
      this.is_free=event.is_free
      this.location = event.location;
      this.event_link = event.event_link;
      this.portal_id = event.portal_id;
      this.event_type = event.event_type;
      if (event.event_extras && event.event_extras.length > 0) {
        this.showExtrasForm = true;
        this.extraForms = event.event_extras.map(extra => ({
          id: extra.extra.id,
          selectedExtra: extra.extra ? extra.extra.name : '',
          items: extra.items.map(item => ({
            id: item.id,
            item_name: item.item_name,
            item_description: item.description,
            item_price: item.price || 0
          }))
        }));

      } else {
        this.showExtrasForm = false;
        this.extraForms = [{
          selectedExtra: '',
          items: [{
            item_name: '',
            item_description: '',
            item_price: 0
          }]
        }];
      }
      if(event.rsvp_list && !event.rsvp_list.length > 0){
        this.show_add_extras=true;
      }
      else{
        this.show_add_extras=false
      }
      if (!this.is_free) {

  this.event_tickets = event.event_tickets; // save it for computed

  event.event_tickets.forEach(et => {
    this.selectedTickets.push(Number(et.ticket.id));
    this.assignedTicketIds.push(Number(et.ticket.id));
  });
} else {
    this.selectedTickets = [];
    this.assignedTicketIds = [];
  }
      // Show the modal immediately
      $('#event_modal').modal('show');


      // Handle description in quill editor if needed
      this.$nextTick(() => {
        if (this.$refs.quilEditEventRef) {
          const quillEditor = this.$refs.quilEditEventRef.getQuill();
          if (quillEditor) {
            const TextDescription = event.description.replace(/<[^>]*>/g, "");
            quillEditor.setContents([
              { insert: TextDescription || "" },
            ]);
          }
        }
      });
    },
    validation_event_form() {
      this.errors = {};
      let isValid = true;

      // 1. Event Name
      if (!this.event_name?.trim()) {
        this.errors.event_name = 'Event name is required';
        isValid = false;
      }

      // 2. Event Type
      if (!this.event_type || !this.event_type.id) {
        this.errors.event_type = 'Please select an event type';
        isValid = false;
      }

      // 3. Organizer
      if (!this.organizer?.trim()) {
        this.errors.organizer = 'Organizer is required';
        isValid = false;
      }

      // 4. Event Link & Location
      if (this.event_type && this.event_type.name) {
        if (this.event_type.name === 'hybrid' || this.event_type.name === 'physical') {
          if (!this.location?.trim()) {
            this.errors.location = 'Location is required';
            isValid = false;
          }
        }
        if (this.event_type.name === "online" || this.event_type.name === "hybrid") {
          if (!this.event_link?.trim()) {
            this.errors.event_link = "Event link is required for online/hybrid events.";
            isValid = false;
          }
        }
      }

      // 5. Dates and Times
      if (!this.start_date) {
        this.errors.start_date = 'Event Start Date is required';
        isValid = false;
      }
      if (!this.end_date) {
        this.errors.end_date = 'Event End Date is required';
        isValid = false;
      }
      if (!this.rsvp_start_date && this.is_free) {
        this.errors.rsvp_start_date = 'RSVP Start Date is required';
        isValid = false;
      }
      if (!this.rsvp_end_date && this.is_free) {
        this.errors.rsvp_end_date = 'RSVP End Date is required';
        isValid = false;
      }
      if (!this.start_time) {
        this.errors.start_time = 'Start Time is required';
        isValid = false;
      }
      if (!this.end_time) {
        this.errors.end_time = 'End Time is required';
        isValid = false;
      }
      if (!this.rsvp_start_time && this.is_free) {
        this.errors.rsvp_start_time = 'RSVP Start Time is required';
        isValid = false;
      }
      if (!this.rsvp_end_time && this.is_free) {
        this.errors.rsvp_end_time = 'RSVP End Time is required';
        isValid = false;
      }

      // Perform date comparison only if all date fields exist
      if (this.start_date && this.end_date && this.rsvp_start_date && this.rsvp_end_date) {
        const todayObj = new Date();
        const startDateObj = new Date(this.start_date);
        const endDateObj = new Date(this.end_date);
        const rsvpStartDateObj = new Date(this.rsvp_start_date);
        const rsvpEndDateObj = new Date(this.rsvp_end_date);

        todayObj.setHours(0, 0, 0, 0);
        startDateObj.setHours(0, 0, 0, 0);
        endDateObj.setHours(0, 0, 0, 0);
        rsvpStartDateObj.setHours(0, 0, 0, 0);
        rsvpEndDateObj.setHours(0, 0, 0, 0);

        if (startDateObj < todayObj) {
          this.errors.start_date = 'Event Start Date must be today or a future date';
          isValid = false;
        }
        if (endDateObj < startDateObj) {
          this.errors.end_date = 'Event End Date must be after Event Start Date';
          isValid = false;
        }
        if (rsvpStartDateObj > startDateObj) {
          this.errors.rsvp_start_date = 'RSVP Start Date must be today or before Event Start Date';
          isValid = false;
        }
        if (rsvpEndDateObj < rsvpStartDateObj || rsvpEndDateObj > startDateObj) {
          this.errors.rsvp_end_date = 'RSVP End Date must be after RSVP Start Date and on or before Event Start Date';
          isValid = false;
        }
      }

      // 6. Extras Validation
      this.extraForms.forEach((extraForm, index) => {
        if (extraForm.selectedExtra) {
          extraForm.items.forEach((item, itemIndex) => {
            if (!item.item_name?.trim()) {
              this.errors[`extra_${index}_item_${itemIndex}_name`] = "Item name is required.";
              isValid = false;
            }
          });
        }
      });

      return isValid;
    }



  },


};